import { ErrorMessage } from "formik";
import React, { useState, useEffect } from "react";
import ReactFancyBox from "react-fancybox";
import {
  Row,
  Col,
  Image,
  Button,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import docx from "../../../images/docx.jpg";
import pdf from "../../../images/pdf.jpg";
const CMSFormFile = (props) => {
  const { name, label, form, required, info } = props;
  let initialImageURL =
    form.values[name] != "null"
      ? process.env.REACT_APP_BACKEND_URL + "public/" + form.values[name]
      : null;

  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(initialImageURL);
  const [fileName, setFileName] = useState("Choose file");
  useEffect(() => {
    if (!image || !image.name) return;
    setImageURL(URL.createObjectURL(image));
    setFileName(image.name);
  }, [image]);

  const onImageChange = (e) => {
    if (e.target && e.target.files[0]) {
      setImage(e.target.files[0]);
      // console.log(e.target.files);
      form.setFieldValue(name, e.target.files[0]);
    } else {
      clearImage();
    }
  };

  const clearImage = async () => {
    // console.log("clearImage callled");
    setImage(null);
    await form.setFieldValue(name, "", true);
    setImageURL(null);
    setFileName(null);
    form.setFieldTouched(name, true);
  };

  return (
    <>
      <div className="form-group ">
        {label !== "" && (
          <>
            {required === true ? (
              <OverlayTrigger
                key={`tooltip-${name}`}
                placement="right"
                overlay={
                  <Tooltip id={`tooltip-right`}>Required field.</Tooltip>
                }
              >
                <label
                  htmlFor={name}
                  className={`required ' ${
                    form.touched[name] && form.errors[name]
                      ? "is-invalidText"
                      : ""
                  }`}
                >
                  {" "}
                  {label}{" "}
                  {info ? <i className="smallInfo">( {info} )</i> : null}
                </label>
              </OverlayTrigger>
            ) : (
              <label
                htmlFor={name}
                className={` ${
                  form.touched[name] && form.errors[name]
                    ? "is-invalidText"
                    : ""
                }`}
              >
                {" "}
                {label} {info ? <i className="smallInfo">( {info} )</i> : null}
              </label>
            )}
          </>
        )}

        {/* <label
          htmlFor={name}
          className={` ${
            form.touched[name] && form.errors[name]
              ? "is-invalidText required"
              : "required"
          }`}
        >
          {" "}
          {label}
        </label> */}
        <div
          className={`input-group ${
            form.touched[name] && form.errors[name] ? "is-invalid" : ""
          }`}
        >
          <div className="input-group-prepend">
            <span
              className="input-group-text"
              id={`${
                form.touched[name] && form.errors[name]
                  ? "is-invalidInputGroupFileAddon01"
                  : "inputGroupFileAddon01"
              }`}
            >
              Upload
            </span>
          </div>
          <div className="custom-file">
            <input
              type="file"
              className="custom-file-input"
              id="file"
              aria-describedby="inputGroupFileAddon01"
              onChange={(e) => onImageChange(e)}
              onBlur={form.handleBlur}
            />
            <label
              className={` ${
                form.touched[name] && form.errors[name]
                  ? "is-invalid custom-file-label"
                  : "custom-file-label"
              }`}
              htmlFor="inputGroupFile01"
            >
              {form.values[name].name
                ? form.values[name].name
                : form.values[name]}
            </label>
          </div>
        </div>
        {form.touched[name] && form.errors[name] && (
          <span id={`${name}-error"`} className="error invalid-feedback">
            <ErrorMessage name={name} />
          </span>
        )}
      </div>
{console.log(imageURL)}
      {/* {form.values[name].name && form.values[name].name.length > 1 && (
        <Row>
          <Col xs={6} md={2} lg={1} className="pageContent ms-2 p-0 ">
            <div className="iconDiv ">
              <i
                className=" fas fa-times position-absolute"
                onClick={() => clearImage()}
              />
            </div>

            {form.values[name].name.includes(".mp4") && (
              <>
                <video width="150" height="150" autoPlay>
                  <source
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      "public/" +
                      form.values[name].name
                    }
                    type="video/mp4"
                  />
                </video>
              </>
            )}
            {form.values[name].name &&
            form.values[name].name.includes(".docx") ? (
              <img className="thumbnail2" src={docx} />
            ) : (
              form.values[name].name &&
              form.values[name].name.includes(".pdf") && (
                <img className="thumbnail2" src={pdf} />
              )
            )}
          </Col>
          <Col></Col>
        </Row>
      )} */}
      {form.values[name].length > 1 && (
        <Row>
          <Col xs={6} md={2} lg={1} className="pageContent ms-2 p-0 ">
            <div className="iconDiv ">
              <i
                className=" fas fa-times position-absolute"
                onClick={() => clearImage()}
              />
            </div>

            {form.values[name].includes(".mp4") && (
              <>
                <video width="150" height="150" autoPlay>
                  <source
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      "public/" +
                      form.values[name]
                    }
                    type="video/mp4"
                  />
                </video>
              </>
            )}
            {form.values[name].includes(".docx") ? (
              <img className="thumbnail2" src={docx} />
            ) : (
              form.values[name].includes(".pdf") && (
                <img className="thumbnail2" src={pdf} />
              )
            )}
          </Col>
          <Col></Col>
        </Row>
      )}
    </>
  );
};

export default CMSFormFile;
